<div
    class="callout"
    [ngClass]="{
        'callout--border-accent': block.data.styleVariant === 'border-accent',
        'callout--border-accent-primary': block.data.accentColor === 'primary',
        'callout--border-accent-secondary': block.data.accentColor === 'secondary',
        'callout--soft-tinted-rounded': block.data.styleVariant === 'soft-tinted-rounded',
        'callout--primary': block.data.themeColor === 'primary',
        'callout--secondary': block.data.themeColor === 'secondary',
        'callout--grey': block.data.themeColor === 'grey',
    }">
    @if (block.data.heading) {
        <h2 class="callout__heading" [innerText]="block.data.heading"></h2>
    }

    @if (block.data.subHeading) {
        <div class="callout__subheading" [innerHTML]="block.data.subHeading"></div>
    }

    @if (block.data.includeCTA) {
        <a
            class="btn callout__cta-link"
            [ngClass]="{
                'btn-primary': block.data.themeColor === 'primary' || block.data.themeColor === 'grey',
                'btn-secondary': block.data.themeColor === 'secondary',
            }"
            [href]="block.data.linkUrl"
            [target]="block.data.externalLink ? '_target' : '_self'">
            <span>{{ block.data.linkText }}</span>

            @if (block.data.externalLink) {
                <ng-container *ngTemplateOutlet="externalLinkIcon"></ng-container>
            }
        </a>
    }
</div>

<ng-template #externalLinkIcon>
    <svg
        class="callout__external-link-icon"
        fill="none"
        height="24"
        viewBox="0 0 26 24"
        width="26"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.6602 7H6.3923C5.22856 7 4.28516 7.89543 4.28516 9V18C4.28516 19.1046 5.22856 20 6.3923 20H15.8744C17.0382 20 17.9816 19.1046 17.9816 18V13"
            stroke=""
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2" />
        <path d="M10.6055 14L21.1412 4" stroke="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
        <path d="M15.875 4H21.1429V9" stroke="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </svg>
</ng-template>
